import cx from 'classnames';
import { useContext } from 'react';
import Sentinel from '@/common/Sentinel';
import { Gallery } from '@/vdp/Gallery';
import Spinner from '@/vdp/Spinner';
import ShowConditionally from '@/vdp/VehicleDetailsContainer/ShowConditionally';
import { useIsDealershipPage } from '~/context/dealership/StaticContext';
import NavigationStickyContext from '~/context/vdp/NavigationStickyContext';
import SpinnerContext from '~/context/vdp/SpinnerContext';
import { useGetIsWIPVehicle } from '~/context/vdp/VehicleContext';
import LoadingImage from './LoadingImage';
import VehicleImage from './VehicleImage';
import Badge from '../Badge';
import { SpinnerWrapper } from '../Hero.styles';

export default function SpinnerHero() {
  const { isSpinnerImmersive, spinnerReady } = useContext(SpinnerContext);
  const { setNavigationSticky } = useContext(NavigationStickyContext);
  const isDealership = useIsDealershipPage();
  const isWIPVehicle = useGetIsWIPVehicle();

  return (
    <div className="flex flex-col pb-0 sm:pb-4xl">
      <SpinnerWrapper>
        {!isDealership && (
          <Badge className="pointer-events-none absolute left-xl top-xl z-10 sm:left-2xl sm:top-2xl" />
        )}
        {spinnerReady.hasError || isWIPVehicle ? (
          <VehicleImage />
        ) : (
          <>
            <LoadingImage isVisible={!spinnerReady.isLoaded} />
            <div className={cx('relative', { 'z-1': !isSpinnerImmersive })}>
              <Spinner />
            </div>
          </>
        )}
      </SpinnerWrapper>
      <Sentinel
        onIntersectionChange={isIntersecting =>
          setNavigationSticky(!isIntersecting)
        }
      />
      <ShowConditionally wip={false} operation="and" mobile={false}>
        <div className="mt-xl">
          <Gallery />
        </div>
      </ShowConditionally>
    </div>
  );
}
